import { IApplicationState } from '../../types/redux';
import { selectOffer } from '../offers';
import { IHighway, IUnderground } from '../../types/offer';

export const selectAddressByOfferId =
  (id: number) =>
  (state: IApplicationState): string => {
    const { geo } = selectOffer(id)(state);

    return geo.address;
  };

export const selectUndergroundByOfferId =
  (id: number) =>
  (state: IApplicationState): IUnderground[] | null => {
    const { geo } = selectOffer(id)(state);

    return geo.undergrounds || null;
  };

export const selectHighwaysByOfferId =
  (id: number) =>
  (state: IApplicationState): IHighway[] | null => {
    const { geo } = selectOffer(id)(state);

    return geo.highways || null;
  };
